const { default: styled } = require("@emotion/styled");

const AITextStyle = styled.strong`
  font-size: 12px;

  @media (max-width: 600px) {
    font-size: 12px;
  }
`;

const SC = {
  AITextStyle,
};

export default SC;
